var meetTheTeamSwiper;

      function initMeetTheTeamSwiper() {
        meetTheTeamSwiper = new Swiper(".fum-meet-the-team-my-swiper", {
          grabCursor: true,
          centeredSlides: false,
          loop: true,
          slidesPerView: "auto",
          loop: true,
          initialSlide: 0,
          spaceBetween: 16,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            bulletClass: "fum-meet-the-team-swiper-pagination-bullet",
            bulletActiveClass:
              "fum-meet-the-team-swiper-pagination-bullet-active",
          },
        });
      }

      document.addEventListener("DOMContentLoaded", () => {
        initMeetTheTeamSwiper();
      });